import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faX } from '@fortawesome/free-solid-svg-icons';
import { Box } from '@mui/material';
import { ColorPickerColors, ColorPickerColorsMap } from '../../../../models/ColorPicker';

interface ColorBlockProps {
  picked: string;
  color: string;
  onPick: (color: string) => void;
}

const ColorBlock = ({ color, picked, onPick }: ColorBlockProps) => (
  <Box
    onClick={() => onPick(color)}
    sx={{
      width: '30px',
      height: '30px',
      backgroundColor: color === 'transparent' || color === 'defaultText' ? 'white' : ColorPickerColorsMap[color as ColorPickerColors] || color,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        color: 'red',
      }}
    >
      {picked === ColorPickerColorsMap[color as ColorPickerColors] || picked === color ? (
        <FontAwesomeIcon icon={faCheck} />
      ) : null}

      {(color === 'transparent' && picked !== color) ? (
        <FontAwesomeIcon icon={faX} />
      ) : null}

      {color === 'defaultText' && picked !== color ? (
        <FontAwesomeIcon icon={faX} />
      ) : null}
    </Box>
  </Box>
);

export default ColorBlock;
